<template>
  <el-dialog title="Finish Review" :close-on-click-modal="false" :visible.sync="visible" width="800px" top="3vh">
    <el-form :model="dataForm" ref="dataForm" autocomplete="off" label-width="110px">
      <el-form-item label="Status" prop="applymentStatus">
        <el-radio-group v-model="dataForm.applymentStatus">
          <el-radio label="QUOTATION_AUDIT_FAIL">Rejected</el-radio>
          <el-radio label="QUOTATION_AUDIT_PASS">Pass</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Remark" prop="remark">
        <el-input
          v-model="dataForm.remark"
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 4 }"
          resize="none"
          placeholder="Remark"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
      <el-form-item label="attachments" prop="attachmentUrls">
        <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        applymentStatus: "QUOTATION_AUDIT_PASS",
        remark: "",
        attachmentUrls: [],
      },
      dataRule: {},
      type: "",
      submitLoading: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions("applyment", ["auditQuotation"]),
    async init() {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.auditQuotation(this.dataForm)
            .then(() => {
              this.visible = false;
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
